<template>
    <div>
      
      <div class="row">    
        <h3>My Locations</h3>
        <div class="col-md-6 mb-1" v-for="location in myLocations" :key="location.id">          
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">{{location.solarId}}</h5>
              {{location.address}}
              <input type="text" class="form-control" v-model="location.friendlyName" placeholder="Friendly Name" />

              <div class="form-check">
                <label class='form-check-label'>
                  <input class="form-check-input" type="checkbox" v-model="location.disabled">Hidden
                </label>
              </div>

              <input type="color" class="form-control form-control-color" v-model="location.color" />


              <button class="btn btn-success me-2" @click="saveLocationChanges(location)">Save</button>
              <button class="btn btn-danger" @click="removeLocation(location)">Remove Location</button>
            </div>
          </div>          
        </div>
      </div> <!-- row -->
      <div class="row">    
        <div class="input-group mb-3" >                
            <button class="btn btn-warning" @click="closeMyLocations()">Close</button>
        </div>
      </div> <!-- row -->
    </div>
  </template>
  
  <script>
  import pb from '../api';
  import { store } from '../store';
  import { useToast } from 'vue-toastification';
  import { confirm } from '@zapadale/vue3-confirm-dialog'

  export default {
    name: 'MyLocations',
    components: {
        //NoteDetails
        //Bar
        //SolarLocation,
        //SolarLocationsMerged
    },
    data() {
      return {
        myLocations: []
      };
    },
    async mounted() {
      this.getLocations();
    },
    methods: {
      removeLocation(location) {
        confirm({
            title: 'Remove Location?',
            message: 'Are you sure you want to remove location ' + location.friendlyName + ' from Solar Share?',
            disableKeys: false,
            auth: false,
            button: {
              no: 'No (Cancel)',
              yes: 'Yes (Remove Location)'
            },
            /**
            * Callback Function
            * @param {Boolean} confirm
            * @param {String} password //if auth:true
            */
            callback: async (confirm) => {
              //if auth:true
              //console.log("confirm: " + confirm);
              //console.log("password: " + password);
              if(confirm) {
                this.removeLocationInternal(location);
                //let toast = useToast();

                //pb.collection('foodsEaten').delete(food.id);
                //this.fetchDailyFoods();
                //toast.success("Food removed");
              }
            }
          });
      },
      async removeLocationInternal(location) {
        let toast = useToast();
        store.isLoading = true;
        try {
          await pb.collection('solarLocations').delete(location.id);
          toast.info("Location removed");
          this.getLocations();
        }
        catch(err){
          toast.error(err);
        }
        finally {
          store.isLoading = false;
        }

      },


        async getLocations() {
           let toast = useToast();
            try {
                let owner = pb.authStore.record.id;
                //console.log("owner is: " + owner);
                const solarLocations = await pb.collection('solarLocations').getList(1, 500, {filter: `owner.id='${owner}'`});  
                //console.log("JSON: " + JSON.stringify(solarLocations));
                console.log("Got [" + solarLocations.items.length + "] solar locations");
                //let items = solarLocations.items;
                //this.solarLocations = solarLocations.items;
                this.myLocations = solarLocations.items;
                console.log("Got [" + this.myLocations.length + "] my locations");
            }
            catch(e) {
                console.log("Error: " + e);
                toast.error("Error: " + e);
            }
            finally {
                store.isLoading = false;
            }
        },
        async saveLocationChanges(location) {
          let toast = useToast();
          store.isLoading = true;
          try {
            await pb.collection('solarLocations').update(location.id, { friendlyName: location.friendlyName, disabled: location.disabled, color: location.color });
            toast.info("Location updated");
            this.getLocations();
          }
          catch(err) {
            toast.error("Error updating: " + err);
          }
          finally {
            store.isLoading = false;
          }
        },
        closeMyLocations() {
          this.$emit('closeMyLocations');
        }
    }
  };
  </script>
  
  <style scoped>  
  .card {
    /*
    cursor: pointer;
    */
  }
  </style>